export default __webpack_public_path__ + "static/media/select-compare-select.67433e84.svg";